import { Interval } from '@debbie/common/dist/economy/payment-plans/index.js';
export const intervalLabel = (interval, lang) => {
    switch (interval) {
        case Interval.LASTBANKDAYMONTH:
            return lang.paymentPlans.lastBankDayOfMonth;
        case Interval.QUARTERLY:
            return lang.paymentPlans.quarterly;
        case Interval.YEARLY:
            return lang.paymentPlans.yearly;
        case Interval['TWO-MONTHS']:
            return lang.paymentPlans.everyOtherMonth;
        case Interval.MONTH:
            return lang.paymentPlans.monthly;
        case Interval['TWO-WEEKS']:
            return lang.paymentPlans.everyOtherWeek;
        case Interval.WEEK:
            return lang.paymentPlans.weekly;
        default:
            return interval ?? lang.paymentPlans.monthly;
    }
};
//# sourceMappingURL=labels.js.map